import { Pipe, PipeTransform } from '@angular/core';
import { PostCrRequest, PostCrResponse } from '../../../../shared/models/v2/post-cr.model';
import { ChronoInput } from '../../../../shared/models/chrono.model';
import { CrActiviteInterne } from '../../../../shared/models/activite-interne/activite-interne.model';
import { CrView } from '../../../../shared/models/v2/cr.model';

/**
 * Calcul le temps réalisé sur les CRs et activités internes
 *
 * @export
 * @class CrTempsRealisePipe
 * @implements {PipeTransform}
 * @returns {Array} Temps réalisé sur les CRs et activités internes
 */
@Pipe({
  name: 'crTempsRealise',
  standalone: true,
})
export class CrTempsRealisePipe implements PipeTransform {
  transform(
    crEnCoursDenvoiFiltered: PostCrRequest[],
    crFiltered: (CrView | ChronoInput | CrActiviteInterne | PostCrResponse)[]
  ): number {
    let tempsRealiseCrActiviteInterne: number = 0;
    let tempsRealiseCr: number = 0;
    let tempsRealiseCrEnCoursDenvoi: number = 0;
    for (let cr of crFiltered) {
      if (cr.type === 'cr-activite-interne') {
        let crActiviteInterne = cr as CrActiviteInterne;
        tempsRealiseCrActiviteInterne += crActiviteInterne.cr_duree_totale;
      }
      if (cr.type === 'cr-response') {
        tempsRealiseCr += cr.duree_totale;
      }
      if (cr.type === 'cr-view') {
        // Brouillon, on ignore
      }
      if (cr.type === 'chrono-input') {
        // Brouillon, on ignore
      }
    }
    for (let cr of crEnCoursDenvoiFiltered) {
      tempsRealiseCrEnCoursDenvoi += cr.duree_totale;
    }
    return tempsRealiseCr + tempsRealiseCrActiviteInterne + tempsRealiseCrEnCoursDenvoi;
  }
}
